import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const CloseIconCircle: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="18" height="18" rx="9" fill="currentColor" />
      <path
        d="M12.5 5.5L5.5 12.5M12.5 12.5L5.5 5.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

CloseIconCircle.displayName = 'CloseIconCircle';
